import { UserFindDto, type UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';
import { booleanSchema } from '@zaoblako/shared/modules/serde/schemas/boolean.schema';

import * as yup from 'yup';

/** Planning scenario response body - DTO signature */
export interface PlanningScenarioFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: number;

  // Tech columns
  /** Creation date and time */
  created: Date;
  /** Last update date and time */
  updated: Date;
  /** Soft deletion update date and time. The planning scenario will be permanently deleted six months after this date. */
  deleted?: Date;
  /** User who created this planning scenario */
  createdBy?: UserFindInterface;

  // Data columns
  /** Planning scenario display name */
  name: string;
  /** Planning scenario additional description */
  description?: string;
  /** Default planning scenario flag. Each tenant can have only one default planning scenario. */
  isDefault?: boolean;
  /** Planning scenario to use in BRS task analytics widget. Each tenant can have only one this planning scenario. */
  useInBrsTaskAnalytics?: boolean;

  // Additional columns
  /** Number of related budget request */
  readonly budgetRequestsCount?: number;
}

/** Planning scenario response body - DTO schema */
export const PlanningScenarioFindDto = SerdeDtoClass.create<PlanningScenarioFindInterface>(FinanceDtoKeysEnum.PLANNING_SCENARIO_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    sortable: true,
    label: 'Создан',
    serializer: yup.date(),
  },
  updated: {
    sortable: true,
    label: 'Изменен',
    serializer: yup.date(),
  },
  deleted: {
    optional: true,
    label: 'Изменен',
    serializer: yup.date(),
  },
  createdBy: {
    optional: true,
    label: 'Автор',
    nested: UserFindDto,
    serializer: (_, nested) => nested,
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  description: {
    sortable: true,
    optional: true,
    label: 'Описание',
    serializer: yup.string(),
  },
  isDefault: {
    sortable: true,
    optional: true,
    label: 'Сценарий по-умолчанию',
    serializer: booleanSchema,
  },
  useInBrsTaskAnalytics: {
    sortable: true,
    optional: true,
    label: 'Аналитика платежей',
    serializer: booleanSchema,
  },
  budgetRequestsCount: {
    optional: true,
    label: 'Количество связанных заявок на бюджет',
    serializer: yup.number(),
  },
});
